<!-- Sales in the marketplace grid, houses in their own (wider) cards below. Tab bodies scroll themselves. -->
<mat-tab-group
  class="h-full [&_.mat-mdc-tab-body-wrapper]:h-full"
  mat-stretch-tabs
  color="primary"
  backgroundColor="accent"
  [(selectedIndex)]="selectedTab"
>
  <mat-tab label="Saved">
    <div class="h-full p-3 sm:p-5">
      <ng-container *ngIf="allBookmarks.length > 0; else noBookmarks">
        <div *ngIf="savedSales.length" class="sale-grid">
          <app-feed-content *ngFor="let sale of savedSales; trackBy: trackById" [post]="sale"></app-feed-content>
        </div>
        <div *ngIf="savedAccommodations.length" class="flex flex-wrap justify-center gap-5 pt-5">
          <app-feed-content *ngFor="let house of savedAccommodations; trackBy: trackById" [post]="house"></app-feed-content>
        </div>
      </ng-container>
      <ng-template #noBookmarks>
        <p class="h-full flex items-center text-center justify-center">
          You haven't saved anything yet.
          <br />
          Tap the bookmark on an item, and it'll show up here.
        </p>
      </ng-template>
    </div>
  </mat-tab>
  <mat-tab label="Post history">
    <div class="h-full p-3 sm:p-5">
      <ng-container *ngIf="allPosts.size; else noPosts">
        <!-- Your own sales: Mark as sold / Delete are on the card. -->
        <div *ngIf="postedSales.length" class="sale-grid">
          <app-feed-content
            *ngFor="let sale of postedSales; trackBy: trackById"
            [id]="'post-' + postKey(sale)"
            class="rounded-xl ring-primary ring-offset-2 transition-shadow"
            [class.ring-2]="highlightedPost === postKey(sale)"
            [post]="sale"
            [ownerActions]="true"
          ></app-feed-content>
        </div>
        <!-- Your own houses: Delete is on the card. -->
        <div *ngIf="postedAccommodations.length" class="house-grid pt-5">
          <app-feed-content
            *ngFor="let house of postedAccommodations; trackBy: trackById"
            [id]="'post-' + postKey(house)"
            class="rounded-xl ring-primary ring-offset-2 transition-shadow"
            [class.ring-2]="highlightedPost === postKey(house)"
            [post]="house"
            [ownerActions]="true"
          ></app-feed-content>
        </div>
      </ng-container>
      <ng-template #noPosts>
        <p class="h-full flex items-center text-center justify-center">
          You haven't posted anything yet.
          <br />
          Post something.
        </p>
      </ng-template>
    </div>
  </mat-tab>
</mat-tab-group>

<!--
  style input button 
  https://stackoverflow.com/questions/572768/styling-an-input-type-file-button 
  from https://stackoverflow.com/questions/47974175/how-do-i-style-a-file-upload-button
-->
<!-- <mat-step [stepControl]="propertyForm.controls.graphics">

          <ng-template matStepLabel>Media of the house details</ng-template>

          <mat-label>Add media files</mat-label>
          
          <button type="button" mat-button mat-raised-button>
            <input type="file" accept="image/*" multiple required (change)="houseMedia($event)">
          </button>

          <div>
            <button type="button" mat-button mat-raised-button matStepperPrevious>Back</button>
            <button type="button" mat-button mat-raised-button matStepperNext>Save draft</button>
            <button type="button" mat-button mat-raised-button matStepperNext>Next</button>
          </div>

        </mat-step> -->

<!-- 
  <mat-card>
    <mat-vertical-stepper #stepper>
      <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="firstFormGroup">
          <ng-template matStepLabel>Fill out your name</ng-template>
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input matInput placeholder="Last name, First name" formControlName="firstCtrl" required>
          </mat-form-field>
          <div>
            <button mat-button mat-raised-button matStepperNext>Next</button>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="secondFormGroup">
        <form [formGroup]="secondFormGroup">
          <ng-template matStepLabel>Fill out your address</ng-template>
          <mat-form-field>
            <mat-label>Address</mat-label>
            <input matInput formControlName="secondCtrl" placeholder="Ex. 1 Main St, New York, NY"
                   required>
          </mat-form-field>
          <div>
            <button mat-button mat-raised-button matStepperPrevious>Back</button>
            <button mat-button mat-raised-button matStepperNext>Next</button>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Done</ng-template>
        <p>You are now done. Submit?</p>
        <div>
          <button mat-button mat-raised-button matStepperPrevious>Back</button>
          <button mat-button mat-raised-button (click)="stepper.reset()">Reset</button>
          <button mat-button mat-raised-button >Submit</button>
        </div>
      </mat-step>
    </mat-vertical-stepper>
  </mat-card>
 -->

<!--
        <mat-accordion class="headers-align">
          <mat-expansion-panel *ngFor="let house of houses" [expanded]="step === 0" (opened)="setStep(0)" hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ house.house_type }}, {{ house.number }}
              </mat-panel-title>
              <mat-panel-description>
                {{ house.street }}
                <span class="price">
                  &#8358;{{ house.price }}
                </span>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div>
              <form class="update-form">
                <div>
                  <mat-label>Add media files</mat-label>
                  <br />

                  <button type="button" mat-button mat-raised-button>
                    <input title="Select file" type="file" accept="image/*" required multiple
                      (change)="houseMedia($event, house.id)" />
                  </button>
                </div>

                <div class="inner-update-form">
                  <mat-form-field>
                    <mat-label>Bathroom</mat-label>
                    <input title="Bathroom" matInput [value]="house.bathrooms" />
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Toilet</mat-label>
                    <input title="Toilet" matInput [value]="house.toilet" />
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Kitchen</mat-label>
                    <input title="Kitchen" matInput [value]="house.kitchen" />
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Bedroom</mat-label>
                    <input title="Bedroom" matInput [value]="house.bedrooms" type="number" min="1" />
                  </mat-form-field>
                </div>
              </form>

              <mat-divider class="mb"></mat-divider>

              <mat-grid-list cols="2" gutterSize="10px" rowHeight="6:4">
                <mat-grid-tile *ngFor="let image of [1,2,3]">
                  <img class="house-image" mat-card-image ngSrc="https://placehold.co/500x250?text=corpers.ng&font=roboto"
                    width="500" height="250" alt="A photo of a room in this house" />
                  <mat-grid-tile-footer>
                    <button type="button" (click)="deleteHouseImage()" mat-icon-button color="basic"
                      aria-label="Delete this picture of this house">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </mat-grid-tile-footer>
                </mat-grid-tile>
              </mat-grid-list>
            </div>
            <mat-action-row>
              <button type="button" mat-button mat-raised-button (click)="updateHouseInfo()">
                Update
              </button>
              <button type="button" mat-button color="primary" (click)="nextStep()">
                Next
              </button>
            </mat-action-row>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)" hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title> Personal data </mat-panel-title>
              <mat-panel-description>
                Type your name and age
                <mat-icon>account_circle</mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-form-field>
              <mat-label>First name</mat-label>
              <input title="First name" matInput />
            </mat-form-field>

            <mat-form-field>
              <mat-label>Age</mat-label>
              <input title="Age" matInput type="number" min="1" />
            </mat-form-field>

            <mat-divider></mat-divider>

            <mat-grid-list cols="2" gutterSize="10px" rowHeight="6:4">
              <mat-grid-tile>
                <img class="house-image" mat-card-image ngSrc="https://placehold.co/500x250?text=corpers.ng&font=roboto"
                  width="500" height="250" alt="A photo of a room in this house" />
                <mat-grid-tile-footer>
                  <button type="button" mat-icon-button color="basic" aria-label="Delete this picture of this house">
                    <mat-icon>delete</mat-icon>
                  </button>
                </mat-grid-tile-footer>
              </mat-grid-tile>
              <mat-grid-tile>
                <img class="house-image" mat-card-image ngSrc="https://placehold.co/500x250?text=corpers.ng&font=roboto"
                  width="500" height="250" alt="A photo of a room in this house" />
              </mat-grid-tile>
              <mat-grid-tile>
                <img class="house-image" mat-card-image ngSrc="https://placehold.co/500x250?text=corpers.ng&font=roboto"
                  width="500" height="250" alt="A photo of a room in this house" />
              </mat-grid-tile>
              <mat-grid-tile>
                <img class="house-image" mat-card-image ngSrc="https://placehold.co/500x250?text=corpers.ng&font=roboto"
                  width="500" height="250" alt="A photo of a room in this house" />
              </mat-grid-tile>
            </mat-grid-list>

            <mat-action-row>
              <button type="button" mat-button color="primary" (click)="nextStep()">
                Next
              </button>
            </mat-action-row>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)" hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title> Destination </mat-panel-title>
              <mat-panel-description>
                Type the country name
                <mat-icon>map</mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-form-field>
              <mat-label>Country</mat-label>
              <input title="Country" matInput />
            </mat-form-field>

            <mat-action-row>
              <button type="button" mat-button color="warn" (click)="prevStep()">
                Previous
              </button>
              <button type="button" mat-button color="primary" (click)="nextStep()">
                Next
              </button>
            </mat-action-row>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)" hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title> Day of the trip </mat-panel-title>
              <mat-panel-description>
                Inform the date you wish to travel
                <mat-icon>date_range</mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-form-field>
              <mat-label>Date</mat-label>
              <input title="Date" matInput [matDatepicker]="picker" (focus)="picker.open()" readonly />
            </mat-form-field>
            <mat-datepicker #picker></mat-datepicker>

            <mat-action-row>
              <button type="button" mat-button color="warn" (click)="prevStep()">
                Previous
              </button>
              <button type="button" mat-button color="primary" (click)="nextStep()">
                End
              </button>
            </mat-action-row>
          </mat-expansion-panel>
        </mat-accordion>  
-->

<!-- 
<mat-card appearance="outlined">
        <form [formGroup]="propertyForm" (ngSubmit)="postHouse()">
          <mat-vertical-stepper [linear]="true" #stepper>
            <mat-step [stepControl]="
                                propertyForm.controls.number &&
                                propertyForm.controls.street &&
                                propertyForm.controls.city_or_town &&
                                propertyForm.controls.state
                            ">
              <ng-template matStepLabel>Fill out the house address</ng-template>
              <div class="add-house">
                <mat-form-field>
                  <mat-label>House number</mat-label>
                  <input matInput placeholder="Flat 10A" formControlName="number" required />
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Street</mat-label>
                  <input matInput placeholder="Eforo street" formControlName="street" required />
                </mat-form-field>

                <mat-form-field>
                  <mat-label>City or Town</mat-label>
                  <input matInput placeholder="Umuahia" formControlName="city_or_town" required />
                </mat-form-field>

                <mat-form-field>
                  <mat-label>State</mat-label>
                  <input matInput placeholder="Jigawa" formControlName="state" required />
                </mat-form-field>
              </div>

              <div class="add-house-buttons">
                
                <button type="button" mat-button mat-raised-button matStepperNext>
                  Next
                </button>
              </div>
            </mat-step>
            <mat-step [stepControl]="
                                propertyForm.controls.house_type &&
                                propertyForm.controls.bedrooms &&
                                propertyForm.controls.kitchen &&
                                propertyForm.controls.toilet &&
                                propertyForm.controls.bathrooms
                            ">
              <ng-template matStepLabel>Fill out the house details</ng-template>

              <div class="add-house">
                <mat-form-field>
                  <mat-label>Places like:</mat-label>
                  <mat-select title="list of places" role="listbox" [formControl]="propertyForm.controls.house_type"
                    required>
                    <mat-option role="option" *ngFor="let houseType of houseTypes"
                      [value]="houseType">{{ houseType }}</mat-option>
                  </mat-select>
                  <mat-hint>How would you best say the house is?
                    Flat, Self-contain, etc.</mat-hint>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Bathrooms</mat-label>
                  <input matInput placeholder="1" formControlName="bathrooms" required />
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Toilet</mat-label>
                  <input matInput placeholder="8" formControlName="toilet" required />
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Bedrooms</mat-label>
                  <input matInput placeholder="15" formControlName="bedrooms" required />
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Kitchen</mat-label>
                  <input matInput formControlName="graphics" placeholder="Shared" formControlName="kitchen" required />
                </mat-form-field>
              </div>
              <div class="add-house-buttons">
                <button type="button" mat-button mat-raised-button matStepperPrevious>
                  Back
                </button>
                <button type="button" mat-button mat-raised-button matStepperNext>
                  Next
                </button>
              </div>
            </mat-step>

            <mat-step [stepControl]="propertyForm.controls.price">
              <ng-template matStepLabel>Done</ng-template>
              <div class="add-house">
                <mat-form-field>
                  <mat-label>Price</mat-label>
                  <input matInput placeholder="₦75,000" formControlName="price" required />
                </mat-form-field>
              </div>

              <div class="add-house-buttons">
                <button type="button" mat-button mat-raised-button matStepperPrevious>
                  Back
                </button>
                <button type="button" mat-button mat-raised-button (click)="stepper.reset()">
                  Reset
                </button>
                <button type="submit" mat-button mat-raised-button type="submit">
                  Submit
                </button>
              </div>
            </mat-step>
          </mat-vertical-stepper>
        </form>
      </mat-card>
     -->
